import React, { useEffect, useCallback } from "react";
import * as styles from "./style.mod.scss";
import CloseIcon from "assets/svgs/close-btn.svg";


const SidePanel = (props) => {
  const {
    title, children, open,
    className, bodyClass, onClose,
    closeIconStyle, titleExtra,
  } = props;

  const ToggleOverlay = () => <span onClick={onClose} className={styles.toggleOverlay} />;

  const escEventHandler = useCallback((event) => {
    if(event.keyCode === 27) {
      if (open) onClose();
    }
  }, [open]);

  useEffect(() => {
    document.addEventListener("keydown", escEventHandler, false);

    return () => {
      document.removeEventListener("keydown", escEventHandler, false);
    };
  }, [open]);

  return (
    <>
      { open && <ToggleOverlay /> }
      <div className={`${styles.sidePanel} ${open ? styles.opened : ""} ${className}`}>
        <div className={`${styles.header} ${title === undefined ? styles.noShadow : ""}`}>
          {
            title &&
              <h5 className={styles.title}>
                { title }
                { titleExtra && <span>{ titleExtra }</span> }
              </h5>
          }
          <a
            className={closeIconStyle ? closeIconStyle : styles.closeIcon}
            onClick={onClose}>
            <CloseIcon />
          </a>
        </div>
        <div className={`${bodyClass} ${styles.panelContent}`}>
          {children}
        </div>
      </div>
    </>
  );
};

export default SidePanel;
